import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from 'router/Router';
import AuthProvider from 'domain/auth/contexts/AuthProvider';
import StorageErrorBoundary from 'components/shared/StorageErrorBoundary';
import DevStorageCleaner from 'components/dev/DevStorageCleaner';
import { MockProvider } from 'domain/contexts/MockProvider';
import TranslationProvider from 'contexts/TranslationProvider';
import SnackbarProvider from 'contexts/SnackbarProvider';
import ModalProvider from 'contexts/ModalProvider';
import RemotesProvider from 'mfe/RemotesProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useEffect(() => {
    import('react-ga4').then(({ default: ReactGA }) => {
      ReactGA.initialize(`${import.meta.env.VITE_GA_TRACKING_ID}`);
    });
  }, []);

  return (
    <StorageErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <MockProvider>
            <TranslationProvider>
              <SnackbarProvider>
                <ModalProvider>
                  <RemotesProvider>
                    <Router />
                  </RemotesProvider>
                </ModalProvider>
              </SnackbarProvider>
            </TranslationProvider>
          </MockProvider>
        </AuthProvider>
      </QueryClientProvider>
      {import.meta.env.DEV && <DevStorageCleaner />}
    </StorageErrorBoundary>
  );
}

export default App;
